if(!customElements.get('product-card-form')){
    class ProductCardForm extends HTMLElement {
        constructor(){
            super();

            this.enabledSizeVariant = this.dataset.sizeVariant == 'true';
            this.openVariantPopup = this.dataset.variantPopup == 'true';
            this.productCard = this.closest('.product-card');
            this.productFormId = this.dataset.id;

            this.variantPopup = document.querySelector('variant-popup');
            this.cartDrawer = document.querySelector('cart-drawer');
            this.addedToCartPopup = document.querySelector('added-to-cart-popup');

            this.form = this.querySelector("form");
            this.buttonCart = this.querySelector('.button-cart');
            if(!this.enabledSizeVariant){
                this.buttonCart.addEventListener("click", this.addToCart.bind(this));
                this.buttonCart.addEventListener("keydown", e => {
                    if(e.key === 'Enter') this.addToCart();
                });
            }else{
                this.labelSizes = this.buttonCart.querySelectorAll('.button-size');
                this.labelSizes.forEach(item => {
                    item.addEventListener("click", this.onClickButtonSize.bind(this));
                    item.addEventListener("keydown", e => {
                        if(e.key === 'Enter') this.onClickButtonSize(e);
                    });
                });
            }
        }

        connectedCallback(){
            this.onSizeUpdateAddToCart = PubSub.subscribe(
                PubSub.events.sizeAddToCart, this.handleSizeValueChange.bind(this)
            )
        }

        disconnectedCallback(){
            if(this.onSizeUpdateAddToCart && typeof this.onSizeUpdateAddToCart === 'function'){
                this.onSizeUpdateAddToCart();
            }
        }

        handleSizeValueChange({data: { productFormId }}){
            if(!productFormId) return;

            if(this.dataset.id === productFormId){
                this.addToCart();
            }
        }

        onClickButtonSize(e){
            const label = e.target.closest('label.button-size');
            const radio = label ? this.querySelector(`input[type="radio"][id="${label.getAttribute('for')}"]`) : null;
            if(radio && !radio.disabled){
                radio.checked = true;
                const data = {
                    event: e,
                    target: radio,
                    selectedOptionValues: this.selectedOptionValues
                }
                this.updateValue(data);
            }
        }

        updateValue(data = {event: null, target: null, selectedOptionValues: null, source: null}){
            PubSub.publish(PubSub.events.productCardSizeValueChange, {
                data: data
            });
        }

        addToCart(){
            if(this.buttonCart.classList.contains('disabled')) return;
            if(this.openVariantPopup){
                this.onOpenVariantPopup();
                return;
            }

            this.onSubmitToCart();
        }

        onOpenVariantPopup(){
            if(!this.form) return;
            if(!this.variantPopup) return;

            const data = {
                productUrl: `${this.dataset.productUrl}`,
                productId: this.form.querySelector('input[name="id"]').value,
                selectedOptionValues: this.selectedOptionValues
            }

            if(!data.productUrl) return;
            if(!data.productId) return;

            PubSub.publish(PubSub.events.onVariantPopup, {
                data: data
            });
        }

        get selectedOptionValues() {
            return Array.from(this.productCard.querySelectorAll('fieldset input:checked')).map(
                ({ dataset }) => dataset.optionValueId
            );
        }

        onSubmitToCart(e){
            // handle error message
            this.handleErrorMessage();

            this.buttonCart.classList.add('disabled');
            this.buttonCart.classList.add('loading');
            this.productCard?.querySelector(".badge--sold-out")?.remove();

            const formData = new FormData(this.form);

            // config
            const config = fetchConfig('javascript');
            config.headers['X-Requested-With'] = 'XMLHttpRequest';
            delete config.headers['Content-Type'];
            config.body = formData;

            fetch(`${routes.cart_add_url}`, config)
            .then(res => res.json())
            .then(res => {
                if(res.status) {
                    PubSub.publish(PubSub.events.cartError, {
                        source: 'product-card',
                        productVariantId: formData.get('id'),
                        errors: res.errors || res.description,
                        message: res.message
                    });

                    this.handleErrorMessage(res.description);

                    // sold out
                    if(this.buttonCart){
                        this.buttonCart.classList.remove('loading');
                        this.buttonCart.classList.remove('inner-group');
                    }

                    const soldoutBadge = document.createElement('span');
                    soldoutBadge.innerHTML = window.cart.badge.sold_out;
                    soldoutBadge.classList.add('badge', 'badge--sold-out', 'my-3', 'max-w-max');

                    if(this.productCard){
                        this.productCard.querySelectorAll(".badge").forEach(item => item.remove());
                        
                        this.productCard.querySelector(".price")?.append(soldoutBadge);
                        this.productCard.querySelector('.price')?.classList.add('price--sold-out');
                        this.productCard.querySelector('.price')?.classList.remove('price--on-sale');
                        this.productCard.querySelector('.price')?.classList.remove('price--no-compare');
                        this.productCard.querySelector('.price')?.classList.remove('volumn-pricing--sale-badge');
                    }

                    this.error = true;
                    return;
                }

                if(!this.cartDrawer){ // if cart drawer is disabled
                    window.location = window.routes.cart_url;
                    return;
                }
                
                this.error = false;

                if(this.addedToCartPopup){
                    this.addedToCartPopup.renderContent(res);
                }else{ // if added to cart popup is disabled
                    this.updateCartSize();
                }
            }).catch(e => {
                console.error(e);
            }).finally(() => {
                this.buttonCart.classList.remove('disabled');
                this.buttonCart.classList.remove('loading');
            });
        }

        handleErrorMessage(message = ""){
            const errorWrapper = this.productCard.querySelector(".error");
            if(!errorWrapper) return;

            errorWrapper.querySelector('small').innerText = `${message}`;
        }

        updateCartSize(){
            const cartIconURL = `/?section_id=header-cart-icon`;
            fetch(cartIconURL)
            .then(res => {
                if (!res.ok) {
                    var error = new Error(res.status);
                    throw error;
                }
                return res.text();
            }).then(text => {
                const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-header-cart-icon').innerHTML;

                const header = document.querySelector('custom-header');
                const cartSizeIcons = header?.querySelectorAll('.cart-item-size');
                if(cartSizeIcons.length > 0){
                    cartSizeIcons.forEach(item => {
                        item.innerText = resultsMarkup.trim();
                        item.setAttribute('aria-hidden', 'false');
                    });
                }
            }).catch(e => {
                console.error(e);
            });
        }
    }

    customElements.define('product-card-form', ProductCardForm);
}